import styled from "styled-components";
import { colors } from "../../styles/variables";

export const StyledBackground = styled.div<{
  backgroundColor: string;
  small?: boolean;
  isDisabled?: boolean;
}>`
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  align-items: center;
  width: 70px;
  height: 48px;
  border-radius: 4px;
  border: 1px solid ${colors.gray300};
  position: relative;
  ${({ backgroundColor }) =>
    backgroundColor &&
    `
    background-color: ${backgroundColor};
  `}
  opacity: ${({ isDisabled }) => (isDisabled ? 0.3 : 1)};
  ${({ small }) =>
    small &&
    `

      width: 36px;
      height: 24px;
  `}
`;
